import { ICorporateAccount } from './corporate-account';
import { IAddress } from './property';
import { Resource, IResource } from './resource';

export interface IUser extends IResource {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  phone?: string;
  is_new?: boolean;
  email_verified?: boolean;
  phone_verified?: boolean;
  bank_cards?: any;
  debit_cards?: any[];
  address?: string | IAddress;
  city?: string;
  state?: string;
  subscribed?: boolean;
  subscription?: any;
  presets?: any;
  avatar?: string;
  referral_code?: string;
  signup_code?: string;
  last_active?: number;
  account_status?: ACCOUNT_STATUS;
  business?: ICorporateAccount
}

// tslint:disable:variable-name
export class User extends Resource implements IUser {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  phone?: string;
  is_new?: boolean;
  email_verified?: boolean;
  phone_verified?: boolean;
  address?: string | IAddress;
  city?: string;
  state?: string;
  subscribed: boolean;
  subscription?: any;
  bank_cards?: any;
  presets?: any;
  avatar?: string;
  last_active?: number;
  account_status?: ACCOUNT_STATUS;
}
// tslint:enable:variable-name

export interface Address {
  house_no: string;
  street: string;
  city: string;
  state: string;
  country: string;
  postcode: string;
}

export interface OnboardBusinessPayload {
  name: string;
  user: string;
  email: string;
  website?: string;
  address: Address;
  tax_no?: string;
}

export interface OnboardResponse {

  success: boolean;
  message?: string;
  // user?: any;
}
export enum ACCOUNT_STATUS {
  PENDING     = 'pending',
  APPROVED    = 'approved',
  DISAPPROVED = 'disapproved',
}

